import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";

import CommonModal from "./CommonModal";
import SalesLeadDatePicker from "../datepicker/SalesLeadDatePicker";

import Modalstyle from "./modal.module.scss";
import Style from "./../../assets/scss/custom.module.scss";
import "./modalstyle.scss";

import privateAxios from "../../utils/axiosPrivate";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";
import { getPostSalesLeadUrl } from "../../utils/constants/apiEndPoints";
import { EditReffPartner } from "../../locales/en";

const AddRefferralSalesLeadModal = ({
  isOpen,
  toggle,
  salesLeadStatus,
  loadSelectedSalesLead
}) => {
  const { id } = useParams();

  const initialSalesLead = {
    salesPersonLeadId: id,
    referralPartnerId: id,
    startDate: null
  };

  const [salesLead, setSalesLead] = useState(initialSalesLead);

  useEffect(() => {
    if (isOpen) {
      setSalesLead((prevState) => ({
        ...prevState,
        startDate: new Date()
      }));
    }
  }, [isOpen]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSalesLead((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (field, selectedDate) => {
    const normalizedDate = selectedDate
      ? new Date(selectedDate.toISOString().split("T")[0])
      : null;
    setSalesLead((prev) => ({ ...prev, [field]: normalizedDate }));
  };

  const handleSalesUpdate = async () => {
    try {
      const dataToSend = {
        salesPersonLeadId: salesLead.salesPersonLeadId,
        referralPartnerId: id,
        startDate: salesLead.startDate
          ? salesLead.startDate.toISOString().split("T")[0]
          : null
      };

      const response = await privateAxios.post(getPostSalesLeadUrl, dataToSend);

      if (response.status === 201) {
        showToast(response.data.message, showToastType.success);
        toggle();
        loadSelectedSalesLead();
      }
    } catch (error) {
      const errMsg =
        error.response?.data?.errors ||
        error.response?.data?.message ||
        showToast(errMsg, showToastType.error);
    }
  };

  const handleClose = () => {
    toggle();
    setSalesLead({
      salesPersonLeadId: id,
      referralPartnerId: id,
      startDate: new Date()
    });
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={handleClose}
      title={EditReffPartner?.addReffModal.title}
      bodyClassName={Modalstyle.commentModalWrap}
      footerButtons={[
        {
          label: EditReffPartner?.editReffModal.updatebtn,
          className: "btn btn-primary",
          onClick: handleSalesUpdate
        }
      ]}
    >
      <div className="row inputWrap">
        <div className="mb-3">
          <p>{EditReffPartner?.editReffModal.salesLead}</p>
          <select
            name="salesPersonLeadId"
            className={`${Style.selectdropdown}`}
            onChange={handleInputChange}
            value={salesLead.salesPersonLeadId}
          >
            <option value="">{EditReffPartner?.editReffModal.choose}</option>
            {salesLeadStatus?.map((data) => (
              <option key={data.id} value={data.id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <p>{EditReffPartner?.editReffModal.startDate}</p>
          <SalesLeadDatePicker
            value={salesLead.startDate}
            onChange={(selectedDate) =>
              handleDateChange("startDate", selectedDate)
            }
          />
        </div>
      </div>
    </CommonModal>
  );
};

AddRefferralSalesLeadModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  salesLeadStatus: PropTypes.array,
  loadSelectedSalesLead: PropTypes.func.isRequired
};

export default AddRefferralSalesLeadModal;
